// ============================
// src/components/ui/HeaderMono.jsx
// ============================
export default function HeaderMono({ children, className = "" }) {
return <h2 className={`text-2xl sm:text-3xl font-bold mb-6 font-mono tracking-tight ${className}`}>{children}</h2>;
}